<button
  pButton
  id="burger"
  (click)="isMenuOpen = !isMenuOpen; emitMenuOpen(isMenuOpen)">
  <i class="pi pi-bars"></i>
</button>
<div
  id="mobile-menu"
  class="absolute top-[5.5rem] md:top-[4.5rem] left-2 w-[95%] bg-white z-30 lg:hidden flex flex-col space-y-3 p-3 rounded-b-lg shadow-md font-app-regular"
  [ngClass]="{ block: isMenuOpen, hidden: !isMenuOpen }">
  <button
    *ngIf="isButtonVisible(ACCUEIL)"
    pButton
    class="rounded-md py-3 px-5 w-full font-bold"
    [routerLink]="[ACCUEIL]"
    (click)="isMenuOpen = false; emitMenuOpen(isMenuOpen)">
    <i class="pi pi-home mr-3"></i>
    {{ "header.home" | translate }}
  </button>
  <button
    *ngIf="isButtonVisible(MON_PROFIL)"
    pButton
    class="rounded-md py-3 px-5 w-full font-bold"
    [routerLink]="[MON_PROFIL]"
    (click)="isMenuOpen = false; emitMenuOpen(isMenuOpen)">
    <i class="pi pi-user mr-3"></i>{{ "header.profil" | translate }}
  </button>
  <button
    *ngIf="isButtonVisible(NOS_OFFRES)"
    pButton
    class="rounded-md py-3 px-5 w-full font-bold"
    [routerLink]="[NOS_OFFRES]"
    (click)="isMenuOpen = false; emitMenuOpen(isMenuOpen)">
    <i class="pi pi-file mr-3"></i>{{ "header.offers" | translate }}
  </button>
  <button
    *ngIf="isButtonVisible(NOUS_CONTACTER)"
    pButton
    class="rounded-md py-3 px-5 w-full font-bold"
    [routerLink]="[NOUS_CONTACTER]"
    (click)="isMenuOpen = false; emitMenuOpen(isMenuOpen)">
    <i class="pi pi-phone mr-3"></i>{{ "header.contact" | translate }}
  </button>
  <hr class="text-light" />
  <app-logout (menuOpenEmitter)="menuLogoutOpen($event)"></app-logout>
</div>
